<!-- id="request_view_dialog_" -->
<div class="control-card-white">

    <div class="control-card-header">
        <ng-container i18n="@@request_view_dialog_title">Richiesta transito</ng-container>
        <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog(false)"></fa-icon>
    </div>

    <div id="content" class="control-card-content">

        <fa-icon icon="trash" class="float-right margin-right-20 icon-clickable" (click)="deleteRequest()"></fa-icon>


        <h4 i18n="@@request_view_dialog_request_details">Dettagli richiesta</h4>

        <table class="simple-table user-add-table">

            <tr *ngIf="!requestPending">
                <td class="text-dark td-left" i18n="@@request_view_dialog_state">Stato</td>
                <td class="td-right">
                    <label class="td-label">{{request.state}}</label>
                </td>
            </tr>


            <tr>
                <td class="text-dark td-left" i18n="@@request_view_dialog_firstname">Nome</td>
                <td class="td-right">
                    <label class="td-label">{{request.firstname}}</label>
                </td>
            </tr>

            <tr>
                <td class="text-dark td-left" i18n="@@request_view_dialog_lastname">Cognome</td>
                <td class="td-right">
                    <label class="td-label">{{request.lastname}}</label>
                </td>
            </tr>

            <tr>
                <td class="text-dark td-left" i18n="@@request_view_dialog_email">Email</td>
                <td class="td-right">
                    <label class="td-label">{{request.email}}</label>
                </td>
            </tr>

            <tr>
                <td class="text-dark td-left" i18n="@@request_view_dialog_phoneNumber">Numero di telefono</td>
                <!-- <td class="td-right" style="width: 30px">
                    <label class="td-label">{{request.prefix}}</label>
                </td> -->
                <td class="td-right">
                    <label class="td-label">{{displayPhoneNumber}}</label>
                </td>
            </tr>

            <tr>
                <td class="text-dark td-left" i18n="@@request_view_dialog_licensePlate">Targa</td>
                <td class="td-right">
                    <label class="td-label">{{request.licensePlate}}</label>
                </td>
            </tr>


            <!-- Se sono gestore indico l'alias a cui è stata fatta la richiesta -->

            <tr *ngIf="!amIAlias">
                <td class="text-dark td-left" i18n="@@request_view_dialog_requested_to">Richiesto a operatore</td>
                <td class="td-right">
                    <label class="td-label">{{request.alias.publicName}}</label>
                </td>
            </tr>

            <tr *ngIf="!amIAlias">
                <td class="text-dark td-left" i18n="@@request_view_dialog_operator_email">Email operatore</td>
                <td class="td-right">
                    <label class="td-label">{{request.alias.alias.email}}</label>
                </td>
            </tr>



            <tr *ngIf="request.documents && hasDocuments">
                <td class="text-dark td-left" i18n="@@request_view_dialog_files">File allegati</td>
                <td>
                    <div *ngIf="documentFiles && Object.keys(documentFiles).length > 0">
                        <div *ngFor="let fileDesc of Object.keys(documentFiles); let last = last">
                            <a [href]="documentFiles[fileDesc].fileUrl" target="_blank" rel="noopener noreferrer">
                                {{fileDesc}}
                            </a>
                            <ng-container *ngIf="!last">
                                <br><br>
                            </ng-container>
                        </div>
                    </div>

                    <div *ngIf="!documentFiles || Object.keys(documentFiles).length === 0">
                        <ng-container i18n="@@request_view_dialog_no_files">Nessun file allegato</ng-container>
                    </div>
                </td>
            </tr>



            <tr>
                <td class="text-dark td-left" i18n="@@request_view_dialog_notes">Note</td>
                <td class="td-right">
                    <label class="td-label">{{request.notes}}</label>
                </td>
            </tr>

            <!-- ---------------------------------------------------------------------------------------------------- -->


            <tr *ngIf="request.accepted">
                <td class="text-dark td-left" i18n="@@request_view_dialog_start_date_accepted">Data inizio</td>
                <td class="td-right">
                    <label class="td-label">{{startDate}}</label>
                </td>
            </tr>


            <tr *ngIf="request.accepted">
                <td class="text-dark td-left" i18n="@@request_view_dialog_end_date_accepted">Data scadenza</td>
                <td class="td-right">
                    <label class="td-label">{{expirationDate}}</label>
                </td>
            </tr>


            <tr *ngIf="request.accepted">
                <td class="text-dark td-left" i18n="@@request_view_dialog_approved_by">Approvato da</td>
                <td class="td-right">
                    <label class="td-label">{{request.approvedBy}}</label>
                </td>
            </tr>

            <tr *ngIf="request.rejected">
                <td class="text-dark td-left" i18n="@@request_view_dialog_rejected_by">Rifiutato da</td>
                <td class="td-right">
                    <label class="td-label">{{request.approvedBy}}</label>
                </td>
            </tr>


            <tr *ngIf="!requestPending">
                <td class="text-dark td-left" i18n="@@request_view_dialog_notes_inserted">Messaggio operatore</td>
                <td class="td-right">
                    <label class="td-label">{{request.acceptRejectNotes}}</label>
                </td>
            </tr>


            <!-- 
        </table> -->

            <tr *ngIf="requestPending">
                <td width="200px" height="80px" class="text-dark" i18n="@@join_dates">Date richiesta transito</td>
                <td>

                    <div id="datesDiv" class="date-wrapper" *ngIf="requestPending">

                        <br>


                        <div id="fromDateDiv" class="date-container">
                            <p class="text-small text-dark" i18n="@@request_view_dialog_start_date">
                                Data di inizio:
                            </p>
                            <input id="from-datepicker-input" [readonly]=true [matDatepicker]="fromDatepicker"
                                value="{{ startDate }}" [formControl]="fromFormControl">
                            <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker #fromDatepicker></mat-datepicker>
                        </div>

                        <div id="toDateDiv" class="date-container">
                            <p class="text-small text-dark" i18n="@@request_view_dialog_expiration_date">
                                Data di fine:
                            </p>
                            <input id="to-datepicker-input" [readonly]=true [matDatepicker]="toDatepicker"
                                value="{{ expirationDate  }}" [formControl]="toFormControl">
                            <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker #toDatepicker></mat-datepicker>
                        </div>

                        <br>

                    </div>

                </td>
            </tr>

            <!-- <table class="simple-table" *ngIf="requestPending"> -->
            <tr *ngIf="requestPending">
                <td class="text-dark td-left" i18n="@@request_view_dialog_approval_notes">Messaggio per il
                    richiedente</td>
                <td class="td-right">
                    <!-- <input [(ngModel)]="acceptRejectNotes" /> -->
                    <textarea [(ngModel)]="acceptRejectNotes"></textarea>
                </td>
            </tr>
        </table>

        <br>
        <br>

    </div>




    <div class="control-card-buttons" *ngIf="requestPending">
        <div>
            <a id="saveButton" (click)="acceptRequest()" class="button">
                <ng-container i18n="@@request_view_dialog_confirm">Accetta richiesta</ng-container> <span>
                    <fa-icon icon="check"></fa-icon>
                </span>
            </a>


            <ng-container *ngIf="error">
                <p class="text-small text-error margin-top-10 display-inline">
                    {{ errorMessage }}
                </p>
            </ng-container>

            <a id="closeButton" (click)="rejectRequest()" class="button">
                <ng-container i18n="@@request_view_dialog_reject">Rifiuta richiesta</ng-container> <span>
                    <fa-icon icon="ban"></fa-icon>
                </span>
            </a>

        </div>

    </div>
</div>


<app-loading-screen #dialogLoader></app-loading-screen>